// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3f2vY","row":"Node_row__3aQ-y","label":"Node_label__3N3i7","footer":"Node_footer__2-bZ3"};